import { ReactComponent as IconInfoRed } from "../Images/icon_info_red.svg";
import "../Styles/fonts.css";
import "../Styles/global.css";

const ErrorMessage = ({ message }) => {
  return (
    <div className="errormessage" style={{ display: "flex" }}>
      <IconInfoRed />
      <p
        style={{
          marginTop: "2px",
        }}
      >
        {message}
      </p>
    </div>
  );
};

export default ErrorMessage;
